import React from 'react'
import PropTypes from 'prop-types'

import { FormattedMessage } from '@dragonraider5/react-intl'
import { showFieldError, renderValidation } from '../../utils/validations'
import { getExceptionMessage } from '../../utils/exceptions'
import { REGISTER_PATH, RECOVER_PASSWORD } from '../MainRoutes/constants'
import { Link } from 'react-router-dom'
import H1 from '../../components/H1'
import { SectionWrapper } from '../../components/Section'
import FormRow from '../../components/FormFields/FormRow'
import TextField from '../../components/FormFields/TextField'
import PasswordField from '../../components/FormFields/PasswordField'
import FormAction from '../../components/FormFields/FormAction'
import FormError from '../../components/FormFields/FormError'
import FormLinks from '../../components/FormFields/FormLinks'
import messages from './messages'

function LoginForm({
  values,
  errors,
  touched,
  status = {},
  isSubmitting,
  handleChange,
  handleBlur,
  handleSubmit
}) {
  return (
    <SectionWrapper>
      <H1>
        <FormattedMessage {...messages.formTitle} />
      </H1>
      <form onSubmit={handleSubmit}>
        <FormRow>
          <TextField
            type='email'
            name='username'
            value={values.username}
            onChange={handleChange}
            onBlur={handleBlur}
            error={showFieldError('username', { errors, touched })}
            help={renderValidation('username', { errors, touched })}
            label={<FormattedMessage {...messages.formFieldUsername} />}
            full
          />
        </FormRow>
        <FormRow>
          <PasswordField
            name='password'
            value={values.password}
            onChange={handleChange}
            onBlur={handleBlur}
            error={showFieldError('password', { errors, touched })}
            help={renderValidation('password', { errors, touched })}
            label={<FormattedMessage {...messages.formFieldPassword} />}
            full
          />
        </FormRow>
        {status.error && (
          <FormError>
            <FormattedMessage {...getExceptionMessage(status.error)} />
          </FormError>
        )}
        <FormAction disabled={isSubmitting}>
          <FormattedMessage {...messages.formButtonSubmit} />
        </FormAction>
      </form>
      <FormLinks>
        <Link to={RECOVER_PASSWORD}>
          ¿Has olvidado tu contraseña?
        </Link>
        <br />
        <Link to={REGISTER_PATH}>
          <FormattedMessage {...messages.registerLink} />
        </Link>
      </FormLinks>
    </SectionWrapper>
  )
}

LoginForm.propTypes = {
  values: PropTypes.shape({
    username: PropTypes.string.isRequired,
    password: PropTypes.string.isRequired
  }).isRequired,
  errors: PropTypes.objectOf(PropTypes.string).isRequired,
  touched: PropTypes.objectOf(PropTypes.bool).isRequired,
  status: PropTypes.shape({
    error: PropTypes.instanceOf(Error),
    success: PropTypes.object
  }),
  isSubmitting: PropTypes.bool.isRequired,
  handleChange: PropTypes.func.isRequired,
  handleBlur: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
}

export default LoginForm
